export class LoadAppInfo {
  public static readonly type = '[AppInfo] Load';
}
